import { BehaviorSubject } from 'rxjs';

export class ContactSupportAIService {
  private _isOpen$ = new BehaviorSubject<boolean>(false);
  isOpen$ = this._isOpen$.asObservable();

  show() {
    this._isOpen$.next(true);

  }

  hide() {
    this._isOpen$.next(false);
  }
}

